<template>
  <div :id="mapId" class="map-container"></div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix ícone quebrado do Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png"
});

// ÍCONES POR STATUS
const iconVerde = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});

const iconVermelho = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});

const iconAmarelo = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-yellow.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});

export default {
  name: "BaseMapa",

  props: {
    imoveis: {
      type: Array,
      required: true
    },
    zoom: {
      type: Number,
      default: 10
    },
    center: {
      type: Array,
      default: () => [-3.7302754051394396, -38.53575510973573]
    }
  },

  data() {
    return {
      map: null,
      mapId: "map-" + Math.random().toString(36).substr(2, 9),
      markerLayerGroup: null
    };
  },

  watch: {
    // Atualiza os pins quando os imóveis mudam
    imoveis: {
      immediate: true,
      handler() {
        if (this.map) {
          this.plotarImoveis();
        }
      }
    }
  },

  mounted() {
    this.initMap();
  },

  beforeUnmount() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },

  methods: {
    // Escolhe o ícone de acordo com o status
    getIcon(status) {
      switch (status) {
        case "DISPONÍVEL": // Disponível
          return iconVerde;
        case "VENDIDO": // Vendido
          return iconVermelho;
        case "EM ANÁLISE": // Em análise
          return iconAmarelo;
        default:
          return iconVerde;
      }
    },

    // Inicializa o mapa Leaflet
    initMap() {
      if (this.map) return;

      this.map = L.map(this.mapId, {
        zoomAnimation: false,
        fadeAnimation: false,
        markerZoomAnimation: false
      }).setView(this.center, this.zoom);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap",
        maxZoom: 19
      }).addTo(this.map);

      this.markerLayerGroup = L.layerGroup().addTo(this.map);

      if (this.imoveis.length) {
        this.plotarImoveis();
      }
    },

    // Plota os imóveis no mapa com cores diferentes
    plotarImoveis() {
      this.map.closePopup();
      this.markerLayerGroup.clearLayers();

      for (const imovel of this.imoveis) {
        if (!imovel.lat || !imovel.lng) continue;

        const marker = L.marker([imovel.lat, imovel.lng], {
          icon: this.getIcon(imovel.status)
        }).addTo(this.markerLayerGroup);

        marker.bindPopup(`
          <b>${imovel.descricao}</b><br>
          Status: ${imovel.status_html}<br>
          Bairro: ${imovel.bairro}<br>
          Cidade: ${imovel.cidade}<br>
          <hr>
          <small>Lat: ${imovel.lat} | Lng: ${imovel.lng}</small>
        `);
      }
    }
  }
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 400px;
  border-radius: 8px;
}
</style>
